<template>
    <div id="app">
        <v-app id="inspire">
            <div>
                <v-toolbar flat color="white">
                    <v-toolbar-title>Certificados</v-toolbar-title>
                    <v-divider
                            class="mx-2"
                            inset
                            vertical
                    ></v-divider>
                    <v-spacer></v-spacer>
                    <v-btn v-if="esconder" color="primary" dark class="mb-2" @click="create()">Novo</v-btn>
                </v-toolbar>
            </div>
            <v-data-table
                v-if="esconder"
                :headers="headers"
                :items="rows"
                class="elevation-1"
                :loading="loading"
                hide-actions
            >
                <template slot="items" slot-scope="props">
                    <td class="text-xs-left">{{ props.item.cnpj }}</td>
                    <td class="text-xs-left">{{ props.item.data_validade }}</td>
                    <td class="text-xs-left">{{ props.item.descricao }}</td>
                    <td class="justify-center layout px-0">
                        <v-icon
                            small
                            class="mr-2"
                            @click="editItem(props.item)"
                        >
                            edit
                        </v-icon>
                        <v-icon
                            small
                            @click="deleteItem(props.item)"
                        >
                            delete
                        </v-icon>
                    </td>
                </template>
            </v-data-table>
            <div class="text-xs-center pa-3">
                <div class="text-center pa-2">
                    <v-progress-circular
                        v-if="mostrar"
                        :indeterminate="indeterminate"
                        :size="200"
                        :width="3"
                        color="light-blue"
                    >Espere terminar de carregar...</v-progress-circular>
                </div>
                <paginate
                    v-if="esconder"
                    :page-count="total"
                    :page-range="10"
                    :page-link-class="'texto'"
                    :margin-pages="2"
                    :click-handler="getData"
                    :prev-text="'Anterior'"
                    :next-text="'Próxima'"
                    :container-class="'pagination'"
                    :page-class="'page-item'"
                    :active-class="'ativa'">
                </paginate>
            </div>
        </v-app>
    </div>
</template>


<script>
    import {sharedService} from '../services'

    export default {
        name: 'Certificados',
        data() {
            return {
                rows: [],
                total: 0,
                loading: false,
                headers: [
                    {
                        text: 'CNPJ',
                        align: 'left',
                        value: 'cnpj'
                    },
                    {text: 'Data de Validade', value: 'data_validade'},
                    {text: 'Descrição', value: 'Descrição'}
                ],
                text: '',
                indeterminate: false,
                esconder: false,
                mostrar: false,
                empresaTes: ''
            }
        },
        computed:{
            empresa: function () {
                let self = this
                self.empresaTes = this.$store.getters.getEmpresa
                return this.$store.getters.getEmpresa
            }
        },
        methods: {
            getTotal() {
                let self = this
                this.mostrar = true
                this.indeterminate = true
                this.esconder = false
                sharedService.read('Certificados?filtros=[["empresas","in","('+self.empresaTes.id+')"]]').then(function (obj) {
                    let totalItens = obj.total_records / 10
                    if (Number.isInteger(totalItens) === true) {
                        self.total = totalItens
                        self.mostrar = false
                        self.indeterminate = false
                        self.esconder = true
                    } else {
                        self.total = parseInt(totalItens.toFixed(1)) + 1
                        self.mostrar = false
                        self.indeterminate = false
                        self.esconder = true
                    }
                })
            },
            getData: async function (pageNum) {
                let self = this
                this.loading = true
                if (pageNum === undefined) {
                    await sharedService.read('Certificados?limit=10&page=1&filtros=[["empresas","in","('+self.empresaTes.id+')"]]').then(function (obj) {
                        self.rows = obj.obj
                        self.loading = false
                    })
                } else {
                    await sharedService.read('Certificados?limit=10&page=' + pageNum+'&filtros=[["empresas","in","('+self.empresaTes.id+')"]]').then(function (obj) {
                        self.rows = obj.obj
                        self.loading = false
                    })
                }
            },
            create() {
                this.$router.push({
                    name: 'CertificadosForm'
                })
            },
            editItem(item) {
                this.$router.push({
                    name: 'CertificadosEdit',
                    params: {id: item.id}
                })
            },
            async deleteItem(item) {
                let self = this
                this.$confirm('Tem certeza que deseja deletar este item?').then(res => {
                    if (res) {
                        sharedService._delete('Certificados', item.id).then(function (obj) {
                            self.getTotal()
                            self.getData()
                            obj.text().then(function (text){
                                self.mostrar = text
                                if(obj.status === 200){
                                    self.$store.dispatch('success', 'Certificado excluido com sucesso!')
                                }  else {
                                    self.$store.dispatch('error', text)
                                }
                            })
                        })
                    } else {
                        this.close()
                    }
                })
            }
        },
        watch:{
            empresa: function () {
                if(this.empresa){
                this.empresaTes = this.empresa
                this.getTotal()
                this.getData()
                }
            }
        },
        beforeMount() {
            this.getTotal()
            this.getData()
        }
    }
</script>

<style>
    .pagination {
        list-style-type: none;
    }

    .page-item {
        border: solid 1px #eeeeee;
        background: #f5f5f5;
        font-size: 15px;
        padding: 13px 16px;
        display: inline-block;
    }

    .ativa {
        background: #bdbdbd;
        border: solid 1px #bdbdbd;
    }

    .texto {
        color: #424242;
    }

</style>
